import clsx from 'clsx';

export default function ContentBody({ className, children, style }) {
  return <div className={clsx('content-body', className)} style={style}>{children}</div>;
}
